// @flow
import React from "react";
import PageContainer from "../containers/PageContainer";
/*import OpenpayCheckout from "../containers/OpenpayCheckout";*/
import { useTranslation } from 'react-i18next';

export default function OpenpayCheckoutView() {
    const { t } = useTranslation();
  return (
      <PageContainer title={t("Openpay")} showShopToolbar={false}>
          <opy-landing-page></opy-landing-page>
    </PageContainer>
  );
}
